import(/* webpackMode: "eager" */ "/vercel/path0/src/app/doi-tac/quy-trinh/page.tsx");
